<script setup lang="ts">
  interface Props {
    fileName: string;
    hasPreviewButton: boolean;
  }
  const props = defineProps<Props>();

  const htmlContent = sanitizeDom(props.fileName);
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="d-flex cursor-pointer">
    <AtomsSvgIcon :width="20" :height="20" img-path="assets/images/icon/pdf.svg" class="pdf-icon" />
    <div class="pdf-name" v-html="htmlContent"></div>
    <div v-if="hasPreviewButton" class="pdf-button">プレビュー</div>
  </div>
</template>

<style lang="scss" scoped>
  .pdf-icon {
    min-width: 20px;
    margin: 4px 4px 0 0;
  }
  .pdf-name {
    margin: 2px 8px 0 4px;
  }
  .pdf-button {
    min-width: 90px;
    height: 28px;
    text-align: center;
    border: 1px white solid;
    border-radius: 5px;
    margin-left: auto;
    padding-top: 2px;
  }
</style>
